import { useEffect, useState } from 'react';
import { formatRegion, nearbyDistances, regionGroups } from '../data/regions';
import { Icon } from './Icon';

type Props = { open: boolean; value: string; onClose: () => void; onApply: (value: string) => void };

export function RegionPicker({ open, value, onClose, onApply }: Props) {
  const [regionId, setRegionId] = useState('');

  useEffect(() => {
    if (!open) return;
    const current = regionGroups.find((region) => value === region.shortName || value.startsWith(`${region.shortName} `));
    setRegionId(current?.id ?? '');
  }, [open, value]);

  if (!open) return null;
  const selectedRegion = regionGroups.find((region) => region.id === regionId);

  return <div className="sheet-backdrop" role="presentation" onMouseDown={onClose}>
    <section className="sheet region-sheet" role="dialog" aria-modal="true" aria-label="지역 선택" onMouseDown={(event) => event.stopPropagation()}>
      <div className="sheet-handle"/>
      <div className="sheet-header"><div><p className="eyebrow">지역 선택</p><h2>{selectedRegion ? `${selectedRegion.shortName}의 시·군·구` : '어디에서 운동할까요?'}</h2></div><button className="icon-button" onClick={onClose} aria-label="닫기"><Icon name="close"/></button></div>
      <div className="region-scroll">
        {!selectedRegion && <>
          <h3>내 주변 거리</h3>
          <div className="distance-grid">{nearbyDistances.map((distance) => <button key={distance} className={value === distance ? 'selected' : ''} onClick={() => onApply(distance)}><Icon name="map" size={17}/>{distance.replace('내 주변 ', '')}</button>)}</div>
          <h3>시·도 선택</h3>
          <div className="province-grid">{regionGroups.map((region) => <button key={region.id} onClick={() => setRegionId(region.id)}><b>{region.shortName}</b><small>{region.name}</small><Icon name="chevron" size={16}/></button>)}</div>
        </>}
        {selectedRegion && <>
          <button className="region-back" onClick={() => setRegionId('')}><span>‹</span> 시·도 다시 선택</button>
          <div className="district-grid">{selectedRegion.districts.map((district) => { const formatted = formatRegion(selectedRegion, district); return <button key={district} className={value === formatted ? 'selected' : ''} onClick={() => onApply(formatted)}>{district}</button>; })}</div>
        </>}
      </div>
    </section>
  </div>;
}
